import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ChatIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.68875 9.90307C2.68875 7.8904 4.3207 6.25874 6.33399 6.25874H13.8497C15.8623 6.25874 17.4941 7.89054 17.4941 9.90307V15.0381C17.4941 17.0513 15.8624 18.6833 13.8497 18.6833H13.0559C12.8213 18.6833 12.5974 18.776 12.4321 18.9413L11.3767 19.9967C10.6668 20.7066 9.51602 20.7066 8.80614 19.9967L7.75074 18.9413C7.58542 18.776 7.3615 18.6833 7.12694 18.6833H6.33399C4.32055 18.6833 2.68875 17.0515 2.68875 15.0381V9.90307ZM6.33399 7.69874C5.11569 7.69874 4.12875 8.68598 4.12875 9.90307V15.0381C4.12875 16.2563 5.11584 17.2433 6.33399 17.2433H7.12694C7.7423 17.2433 8.33281 17.4869 8.76898 17.9231L9.82435 18.9784C9.97191 19.126 10.2109 19.126 10.3584 18.9784L11.4138 17.9231C11.85 17.4869 12.4405 17.2433 13.0559 17.2433H13.8497C15.0668 17.2433 16.0541 16.2563 16.0541 15.0381V9.90307C16.0541 8.68583 15.0669 7.69874 13.8497 7.69874H6.33399Z"
        fill={props.fill || "currentColor" || "#747981"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2517 4.03125C9.02763 4.03125 8.04376 5.01688 8.04376 6.23181V6.97899C8.04376 7.37665 7.7214 7.699 7.32376 7.699C6.92611 7.699 6.60376 7.37665 6.60376 6.97899V6.23181C6.60376 4.2189 8.23504 2.59125 10.2517 2.59125H17.7676C19.7788 2.59125 21.4091 4.21995 21.4091 6.23181V11.3677C21.4091 13.3852 19.7798 15.0149 17.7676 15.0149H16.9746C16.9526 15.0149 16.9309 15.017 16.8591 15.024L16.8435 15.0255C16.4477 15.064 16.0957 14.7743 16.0572 14.3786C16.0187 13.9828 16.3084 13.6307 16.7041 13.5923C16.71 13.5917 16.7165 13.591 16.7238 13.5903C16.7795 13.5847 16.8764 13.5749 16.9746 13.5749H17.7676C18.983 13.5749 19.9691 12.5914 19.9691 11.3677V6.23181C19.9691 5.01583 18.9841 4.03125 17.7676 4.03125H10.2517Z"
        fill={props.fill || "currentColor" || "#747981"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2013 12.6107C11.2013 12.0624 11.6456 11.6175 12.1943 11.6175C12.7425 11.6175 13.1875 12.0618 13.1875 12.6107C13.1875 13.1594 12.7425 13.6038 12.1943 13.6038C11.6456 13.6038 11.2013 13.1588 11.2013 12.6107Z"
        fill={props.fill || "currentColor" || "#747981"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.70312 12.6107C6.70312 12.0624 7.14746 11.6175 7.69618 11.6175C8.24431 11.6175 8.68938 12.0618 8.68938 12.6107C8.68938 13.1594 8.24432 13.6038 7.69618 13.6038C7.14746 13.6038 6.70312 13.1588 6.70312 12.6107Z"
        fill={props.fill || "currentColor" || "#747981"}
      />
    </svg>
  );
};

export default ChatIcon;
